import { ContentChild, Directive, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { TableService } from '../table.service';
import { TableRowTemplateDirective } from './table-row-template.directive';

@Directive({ selector: '[columnSort]' })
export class ColumnSortDirective {
  @Input() columnSort: any = {};
  @Input() order = -1;
  @Output() sort = new EventEmitter();

  constructor(public tableService: TableService) {}

  @HostListener('click', ['$event']) onClick($event: any) {
    if (this.columnSort.sort === false) {
      return;
    }
    this.columnSort.order = this.columnSort.order === 1 ? -1 : this.columnSort.order === -1 ? 0 : 1;
    this.sort.emit(this.columnSort);
    this.tableService.$sort.next(this.columnSort);
  }
}
